//import liraries
import React, {  useEffect, useState } from "react";
import { View, Text, Image, TouchableOpacity, FlatList, ScrollView } from "react-native";
import CustomButton from "../../common/CustomButton";
import { getAutoRechargeDtls, updateAutoRechargeStatus, getPoolAccountdetail } from "./../../api/apiManager";
import { getVehicleTxnData, } from "./../../api/serviceRequest";
import * as RootNavigation from "../../utilities/RootNavigation";
import ModalAlertForTwoButtons from "../../common/ModalAlertForTwoButtons";
import ModalAlert from "../../common/ModalAlert";
import CText from "../../common/CText";
import CHeader from "../../common/CHeader";
import GetMaxAnimatedButton from "../../common/GetMaxAnimatedButton";
import Loader from "../../common/Loader";
import { useLocation } from "react-router-dom";
import useStyles from "./VehicleDetails_Styles";
import CQrCodeModal from "../../common/CQrCodeModal";
import CImage from "../../common/CImage";
import {get,isEmpty} from "lodash"
import { useDeviceSize } from "rn-responsive-styles";
import { getStatements } from "../../api/statementApi";


// create a component
const VehicleDetails = (props) => {

  const rechargeNotAllowed = global?.recharge_not_allowed || []

  const styles = useStyles();
  const { state } = useLocation()
  const selectedVrn = state?.selectedVrn?.vrn
  const selectedTagId = state?.selectedVrn?.fastagId
  const selectedVrnData = [state?.selectedVrn]
  const [isAutopayEnabledFlag, setIsAutopayEnabledFlag] = useState("")
  const [loading, setLoading] = useState(false);
  const [txnDetails, setTxnDetails] = useState([]);
  const [switched, setSwitched] = useState(false);
  const [errModalVisible, setErrModalVisible] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [connfirmDisable, setConfirmDisable] = useState(false);
  const [qrModal, setQrModal] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "Auto Recharge is active. Would you like to edit or disable it?",
    navigateScreen: "",
    actionButton: "",
  });
  const deviceSize = useDeviceSize()
  const isSmallScreen = deviceSize === "small" || deviceSize === "extrasmall"
  console.log(selectedVrnData,"selectedVrnDataselectedVrnData")
  const onCloseModal = () => {
    if (selectedVrnData[0]?.status == "Closed by NPCI") {
      RootNavigation.navigate("Profile/MyVehicles")
    } else { setAlertModalVisible(false); }
  };
  const qrcodeClcik = () => {
    setQrModal(true)
  }
  const onCloseQrModal = () => {
    setQrModal(false)
  }
 useEffect(() => {
    if (isEmpty(selectedVrnData[0])) {
   RootNavigation.navigate("Profile/MyVehicles") }
  }, [selectedTagId]);

  useEffect(() => {
    if (selectedVrnData[0]?.status == "Closed by NPCI") {
      if (selectedVrnData[0]?.fastagBalance > 0) {
        setAlertModal({
          title: "Closed by NPCI",
          status: "",
          message: "This tag was forcefully closed by NPCI. Please proceed with tag closure to claim the balance available in the tag.",
          navigateScreen: "",
          actionButton2: "Claim Balance",
          actionButton1: "Ok",
        })
        setErrModalVisible(true)
      } else {
        setAlertModal({
          title: "Closed by NPCI",
          status: "",
          message: "This tag was forcefully closed by NPCI. Please proceed with tag closure to claim the balance amount (if any)",
          navigateScreen: "",
          actionButton: "",
        })
        setAlertModalVisible(true)
      }
    } else {
      getVehicleTxnDetails();
      getAutoRechargeDetails();
      getPoolAccountDtls()
    }
  }, []);

  const updateCreditStatus = () => {
    var params = {
      isAutoRechEnabled: "N",
      vrn: selectedVrn,
      poolAccountNumber: "",
    };
    setLoading(true);
    updateAutoRechargeStatus(params)
      .then((res) => {
        if (res.statusCode == 1003 || res.statusCode == 200) {
          setLoading(false);
          setAlertModal({
            title: "Successful",
            status: "success",
            message:
              "As per your request, we have disabled Auto Recharge for your FASTag wallet.",
            navigateScreen: "HomeScreen",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          getAutoRechargeDetails();
        } else if (
          res.statusCode == -1052 ||
          res.statusCode == 500 ||
          res.statusCode == -1017 ||
          res.statusCode == -1003 ||
          res.statusCode == -1004
        ) {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "HomeScreen",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setLoading(false);
      });
  };

  const getAutoRechargeDetails = () => {
    setLoading(true);
    let fastagId = "";
    if (selectedVrnData?.length && selectedVrnData[0]?.fastagId?.length) {
      fastagId = selectedVrnData[0].fastagId;
    }
    let params = {
      vrn: selectedVrn,
      poolAccountNumber: "",
      tagId: fastagId
    };
    getAutoRechargeDtls(params)
      .then((res) => {
        setSwitched(res?.data?.isAutoRechEnabled == "Y" ? true : false);
      })
      .catch(() => { })
      .finally(() => {
        setLoading(false);
      });
  };

  const getVehicleTxnDetails = () => {
        let params = {
      userId: global.userCd,
      vrn: selectedVrn,
      statementType: "CONSOLIDATED",
      periodOfStmt: 1, 
      poolAccountNo: "",
      customFrom: "",
      customTo:"",
      priceFrom: 0, 
      priceTo: 1000000,
      pageNo: 0,
      transactionType: ""
    };
    getStatements(params)
      .then((res) => {
        if (res) {
          setTxnDetails(res.transactions);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("<------------ error in txn details ----------->");
      });
  };
console.log(txnDetails)
  const onPressMaxPro = () => {
    global.selectedVehicleForMax = selectedVrn
    global.selectedVrnFromVDForMP = selectedVrn
    global.selectedVrnFromVDForMPTagId = selectedTagId
    global.mpExipryDate = selectedVrnData[0]?.maxProExpiryDate
    global.optIn = true
    global.navFromDB = false
    global.navFromVD = true
    global.navFromOS = false
    RootNavigation.navigate("OtherServices/maxpro", { screen: "alignedServices", })
    global.activeScreen = "UsedCarLoan"
  }

  const onPressOptMaxPro = () => {
    global.selectedVehicleForMax = selectedVrn
    global.selectedVrnFromVDForMP = selectedVrn
    global.selectedVrnFromVDForMPTagId = selectedTagId
    global.optIn = false
    global.navFromDB = false
    global.navFromVD = true
    global.navFromOS = false
    RootNavigation.navigate("OtherServices/maxpro", { screen: "alignedServices", })
    global.activeScreen = "UsedCarLoan"
  }
  const getPoolAccountDtls = () => {
    getPoolAccountdetail()
      .then((res) => {
        setLoading(false);
        setIsAutopayEnabledFlag(res?.autopayEnabledFlag)
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const kyvblock = () => {
    let bgColor = "#FAF4F6" //"#F0F9FF" -- for complete
    let status = "Pending"
    if(selectedVrnData[0]?.kyvCompliant){
      bgColor = "#F0F9FF"
      status = "Completed"
    }
   

    return <>
      <View style={[styles.KYVBLock, { backgroundColor: bgColor}]}>
        <View style={styles.mpCovered}>
          <View style={styles.mpCoveredText}>
            <CText.cancelPolicyConfirmText>{"KYV (Know Your Vehicle)"}</CText.cancelPolicyConfirmText>
            <CText.kycTypeText>{status}</CText.kycTypeText>
          </View>
          {status == "Pending" ?<View style={styles.updateKYV}>
                <CustomButton
                  text={"Update"}
                  onPress={() => {
                    RootNavigation.navigate("Profile/MyVehicles/updateKyv",{backNavigation:"Profile/MyVehicles",vrn:selectedVrn})
                  }}
                />
              </View> : <CImage.KYVCompleteIcon></CImage.KYVCompleteIcon> }
          </View>
      </View>
    </>
  }

  return (
    <View style={styles.container}>
      {loading && <Loader />}
      <CHeader showBack onPress={() => RootNavigation.navigate("Profile/MyVehicles")} disputeHeader  title={!isSmallScreen ? selectedVrn : null}
        qrCode={!rechargeNotAllowed.includes(selectedVrnData[0]?.status)} qrcodeClcik={qrcodeClcik} />
      
      <View style={styles.contentStyle}>
        <View style={styles.detailsViewStyle}>
          <View style={[styles.viewStyle1]}>
            <View style={styles.firstRowStyle}>
              <View style={{ flexDirection: "row" }}>
                <Image
                  source={require("../../assets/images/car.png")}
                  style={styles.vehicleImageStyle}
                />
                <View style={{ marginLeft: 10 }}>
                  <Text style={styles.vehicleNumTextStyle}>
                    {selectedVrn}
                  </Text>
                  <Text style={styles.fastagIdTextStyle}>
                    {"FASTag #"}
                    {selectedVrnData[0]?.fastagId}
                  </Text>
                  <Text style={styles.amountTextStyle}>
                    {"\u20B9  "} {selectedVrnData[0]?.fastagBalance.toFixed(2)}
                  </Text>
                  <View>
                    {selectedVrnData[0]?.status && selectedVrnData[0]?.status != "Activated" && (
                      <View style={styles.imageWrapper} >
                        <Image
                          source={
                            selectedVrnData[0].status == "Hotlisted by service provider" || selectedVrnData[0].status == "Closed by NPCI"
                              ? require("../../assets/images/hotlisted_icon.png")
                              : selectedVrnData[0].status == "Low Balance"
                                ? require("../../assets/images/lowbalance_icon.png")
                                : selectedVrnData[0].status == "Blacklist"
                                  ? require("../../assets/images/blacklisted_icon.png")
                                  : null
                          }
                          style={{ height: 16, width: 16, top: 0 }}
                        />
                        <Text
                          style={[
                            styles.lowBalanceText,
                            {
                              color:
                                selectedVrnData[0].status == "Hotlisted by service provider" || selectedVrnData[0].status == "Closed by NPCI"
                                  ? "#e9730d"
                                  : selectedVrnData[0].status == "Low Balance"
                                    ? "#ff0000"
                                    : selectedVrnData[0].status == "Blacklist"
                                      ? "#880000"
                                      : "",
                            },
                          ]}
                        >
                          {selectedVrnData[0].status}
                        </Text>
                      </View>
                    )}
                  </View>
                </View>
              </View>
              <View style={styles.vehicleViewStyle}>
              </View>
              <View style={styles.rechargeBtn}>
                <CustomButton
                  text={"Recharge"}
                  onPress={() => {
                    RootNavigation.navigate("Recharge")
                    global.activeScreen = "Recharge"
                  }}
                />
              </View>
            </View>
          </View>
          <View style={styles.secondRowStyle}>
            <View style={styles.maxProViewStyle}>
              <View style={[styles.backIconViewStyle, { justifyContent: 'space-between' }]}>
                <View>
                  <Text style={styles.autoRechargeTextStyle}>{"Auto-recharge"}</Text>
                  <CText.kycTypeText>{switched ? "Active" : "In Active"}</CText.kycTypeText>
                </View>
                <TouchableOpacity
                  style={{
                    backgroundColor: switched ? "#00d54f" : "#eeeeee",
                    width: 44,
                    height: 21,
                    borderRadius: 11.7,
                    justifyContent: "center",
                  }}

                  onPress={() => {
                    if (["Activated", "Issued", "Low Balance", "Hotlisted"].includes(selectedVrnData[0]?.status) && isAutopayEnabledFlag == "N") {
                      switched
                        ? setErrModalVisible(true)
                        : RootNavigation.navigate("Profile/MyVehicles/AutoRecharge", { selectedVrnData: selectedVrnData })
                    }
                  }}
                >
                  <View
                    style={{
                      width: 18.8,
                      height: 18.8,
                      borderRadius: 9.4,
                      backgroundColor: "#ffffff",
                      marginHorizontal: 1,
                      alignSelf: switched ? "flex-end" : "flex-start",
                    }}
                  />
                </TouchableOpacity>
              </View>
            </View>
            <View style={[styles.maxProViewStyle, { backgroundColor: "#f3f3f3" }]}>
              <View style={styles.mpCovered}>
                <View style={styles.mpCoveredText}>
                  <CText.cancelPolicyConfirmText>{"FASTag MAX"}</CText.cancelPolicyConfirmText>
                  <CText.kycTypeText>{"Manage"}</CText.kycTypeText>
                </View>
              {Array.isArray(txnDetails) && txnDetails.length > 0 ? (
                txnDetails[0].maxProStatus === "Enabled" ? (
                  <GetMaxAnimatedButton isOpted onPress={() => onPressMaxPro()} />
                ) : (
                  <GetMaxAnimatedButton onPress={() => onPressOptMaxPro()} />
                )
              ) : null}
              </View>
            </View>
          </View>
        </View>
       {kyvblock()}
      </View>
     
      <View style={styles.rechargeTranContainer}>
        <View style={styles.cardContainer}>
          <View style={styles.cardDetails}>
            <ScrollView showsHorizontalScrollIndicator={false} horizontal={true}>
              <View style={{ width: "100%", borderRadius: 20, height: "90%" }}>
                <View style={styles.headerViewStyle}>
                  <Text style={[styles.headerTextStyle, { width: 120, minWidth: 120 },]}>
                    {"Transaction Date & TIme"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text
                    style={[
                      styles.headerTextStyle,
                      { width: 120, minWidth: 120 },
                    ]}
                  >
                    {"Value Date & TIme"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={[styles.headerTextStyle, { width: 140, minWidth: 140 }]}>
                    {"Transaction No."}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={[styles.headerTextStyle, { width: 180, minWidth: 180 }]}>
                    {"Transaction Details"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={styles.headerTextStyle}>{"Debit Amount"}</Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={styles.headerTextStyle}>{"Credit Amount"}</Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={styles.headerTextStyle}>{"Balance Amount"}</Text>
                </View>

                <FlatList
                  style={{}}
                  showsVerticalScrollIndicator
                  data={txnDetails}
                  showsHorizontalScrollIndicator
                  keyExtractor={(item, index) => index + "_" + item?.id?.toString()}
                  renderItem={({ item, index }) => {
                    return (
                      <View>
                        <View style={[styles.dataViewStyle, { backgroundColor: index % 2 !== 0 ? "#ffffff" : "#E5E5E5" },]}>
                          <Text style={[styles.rowStyle, { width: 120, minWidth: 120 }]} >
                            {get(item, "dateTime", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={[styles.rowStyle, { width: 120, minWidth: 120 }]}>
                            {get(item, "dateTime", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={[styles.rowStyle, { width: 140, minWidth: 140 }]}>
                            {get(item, "transId", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={[styles.rowStyle, { width: 180, minWidth: 180 }]}>
                          {get(item, "activity", "") + (get(item, "tollPlazaName", "") ? " - " + get(item, "tollPlazaName", "") : "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={styles.rowStyle}>
                               {get(item, "debitTag", "-")} 
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={styles.rowStyle}>
                               {get(item, "creditTag", "-")}
                          </Text>
                          <View style={[styles.verticalLineStyle, {}]} />
                          <Text style={[styles.rowStyle, {}]}>
                            {get(item, "closingTagBalance", "-")}
                          </Text>
                        </View>
                        <View style={styles.verticalLineStyle} />
                      </View>
                    );
                  }}
                />
              </View>
            </ScrollView>
          </View>
        </View>
      </View>
     
      {errModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlertForTwoButtons
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton1={alertModal.actionButton1 || "Edit"}
            actionButton2={alertModal?.actionButton2 || "Disable"}
            onPressActionButton1={() => {
              if (alertModal?.title == "Closed by NPCI") {
                RootNavigation.navigate("Profile/MyVehicles")
              } else {
                RootNavigation.navigate("Profile/MyVehicles/AutoRecharge", { selectedVrnData: selectedVrnData })
                setErrModalVisible(false);
              }
            }}
            onPressActionButton2={() => {
              if (alertModal?.title == "Closed by NPCI") {
                RootNavigation.navigate("ServiceRequest/SelectVehicleForTagClosure")
              } else {
                setConfirmDisable(true);
                setErrModalVisible(false);
              }
            }}
            closeModal={true}
            onCloseModal={() => {
              setErrModalVisible(false);
            }}
          />
        </View>
      ) : null}
      {connfirmDisable ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlertForTwoButtons
            title={"Alert"}
            status={"error"}
            message={
              "Are you sure you want to disable Auto-Recharge. You can turn it on again later"
            }
            navigateScreen={alertModal.navigateScreen}
            actionButton1={"Cancel"}
            actionButton2={"Disable"}
            onPressActionButton1={() => {
              setConfirmDisable(false);
            }}
            onPressActionButton2={() => {
              getAutoRechargeDetails()
              updateCreditStatus();
              setConfirmDisable(false);

            }}
          />
        </View>
      ) : null}
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
      {qrModal ?
        <View style={styles.overlayViewStyle}>
          <CQrCodeModal data={state?.selectedVrn} onCloseModal={onCloseQrModal} />
        </View> : <></>}
    </View>
  );
};

//make this component available to the app
export default VehicleDetails;
